import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"

export const TakedownProcessStatusOptionList: KSelectOption[] = [
  { label: "Not Started", value: 1, value2: "not_started" },
  { label: "Preparing Metadata", value: 2, value2: "preparing_metadata" },
  { label: "Audio Download", value: 3, value2: "audio_download" },
  { label: "Audio Asset Upload", value: 4, value2: "audio_asset_upload" },
  { label: "Match Pending", value: 5, value2: "match_pending" },
  { label: "Takedown In Progress", value: 6, value2: "takedown_in_progress" },
  { label: "Payment In Progress", value: 7, value2: "payment_in_progress" },
  { label: "Closed", value: 8, value2: "closed" }
]

export const getTakedownProcessStatusLabel = (status?: string) => {
  return TakedownProcessStatusOptionList.find((option) => option.value2 === status)?.label || status || "-"
}

export const formatTakedownStatusLogDate = (date?: string) => {
  return date ? date.replace("T", " ").substring(0, 16) : "-"
}
